module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("Christ keep the Hollow Land "), _c('br'), _vm._v("Through the sweet spring-tide "), _c('br'), _vm._v("When the apple blossoms bless "), _c('br'), _vm._v("The lowly bent hill side. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Christ keep the Hollow Land "), _c('br'), _vm._v("All the summer-tide "), _c('br'), _vm._v("Still we cannot understand "), _c('br'), _vm._v("Where the waters glide. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Only dimly seeing them "), _c('br'), _vm._v("Coldly slipping through "), _c('br'), _vm._v("Many green-lipp’d cavern mouths, "), _c('br'), _vm._v("Where the hills are blue. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("—W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLIAM ")]), _vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORRIS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2580787d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hollowland_00000.vue
// module id = 66
// module chunks = 0